<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 533.5 544.3"
  className="w-4 h-4 flex-shrink-0"
>
  <path
    fill="#4285F4"
    d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.6-117.4 81.6-201.1z"
  />
  <path
    fill="#34A853"
    d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-153.8-112.3H28.9v70.1c46.2 91.9 140.3 154.1 243.2 154.1z"
  />
  <path
    fill="#FBBC05"
    d="M118.3 324.3c-11.6-33.8-11.6-70.7 0-104.5V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l89.4-70.1z"
  />
  <path
    fill="#EA4335"
    d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.5l76.9-76.9C405.6 24.1 339.2-.3 272.1 0 169 0 74.9 62.2 28.7 154.3l89.4 70.1c22.6-64.4 82.8-112.3 153.9-112.3z"
  />
</svg>
